var render = function render(){var _vm=this,_c=_vm._self._c;return _c('listSuncategoriesMarketplaceComponent',{attrs:{"category":_vm.category}})
}
var staticRenderFns = []

export { render, staticRenderFns }